import AOS from 'aos';
import { isCrawlerUserAgent } from 'is-web-crawler';
import SimpleParallax from 'simple-parallax-js';
import CursorFollow from "./CursorFollow";

export default {
    init() {
        if (isCrawlerUserAgent()) {
            let aosElements = document.querySelectorAll('[data-aos]');

            Array.from(aosElements)
                .forEach(el => {
                    if (el.dataset.aos) {
                        el.dataset.noAos = el.dataset.aos;
                        el.dataset.aos = "false";
                    }
                });
        } else {
            AOS.init({
                duration: 700
            });
            this.initCursorFollow();
            this.initProgressBar();
            this.initHeaderParallax();
        }
    },
    initProgressBar() {
        const updateProgressBar = () => {
            let navElement = document.getElementById('nav-primary');
            let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            let scrolled = (winScroll / height) * 100;

            document.querySelector('.progress-bar').style.width = scrolled + "%";
            document.querySelector('.progress-container').classList.toggle('fixed', winScroll > navElement.offsetHeight);
        }

        if (document.querySelector('.progress-container')) {
            updateProgressBar();
            window.addEventListener('scroll', updateProgressBar);
        }
    },
    initHeaderParallax() {
        const selectors = [
            '.header--single-work .header__picture > img',
            '.header--single-work .header__media',
            // FIXME: home page header video parallax white space caused by parallax offset
            // '.header--home .header__picture > img',
            // '.header--home .header__media'
        ];
        const img = document.querySelector(selectors.join(', '));
        const options = {
            delay: 0,
            orientation: 'down',
            scale: 1.7,
            overflow: true,
        };

        if (img) {
            img.parallax = new SimpleParallax(img, options);
        }
    },
    initCursorFollow() {
        if (document.querySelector('.cursor')) {
            Array.from(document.querySelectorAll('.cursor'))
                .forEach(el => el.cursorFollow = new CursorFollow(el));
        }
    }
}
